import { create } from 'zustand';
import { Payment } from '../../../core/types';
import * as api from '../../../core/api/services';
import { storageMgt } from '../../../core/utils/storage';

interface PaymentState {
  initiatePayment: (data: any) => Promise<any>;
  userPayments: () => Promise<Payment[]>;
  checkPaymentStatus: (reference: string) => Promise<any>;
}

export const usePaymentStore = create<PaymentState>(() => ({
  initiatePayment: async (data: any) => {
    try {
      return await api.initiatePayment(data);
    } catch {
      return null;
    }
  },

  userPayments: async () => {
    try {
      const user = storageMgt.getUser();
      if (!user?.id) return [];
      return await api.getUserPayments(user.id);
    } catch {
      return [];
    }
  },

  checkPaymentStatus: async (reference: string) => {
    try {
      return await api.checkPaymentStatus(reference);
    } catch {
      return null;
    }
  },
}));
